import { Product } from '@/types';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';

export const fetchProductForSellable = (sellableId: string) =>
  requestToJSON<Product>(getRequest(`/api/v1/sellables/${sellableId}/representations/product`));
